export const MessagesAnswers = {
  Id: 'Identifikátor',
  Message: 'Zpráva',
  DateAnswer: 'Datum odpovědi',
  DatePreview: 'Datum náhledu',
  DateRead: 'Datum přečtení',
  AnswerName: 'Odpověď',
  AnswerValues: 'Hodnoty odpovědi',
};
